<script>

    import { toast } from 'bulma-toast'
    import { UserStore, WalletStore } from '../stores'

    import WalletsService from '../$services/wallets.service'

    import Spinner from '../$components/spinner.svelte'
    import Value from '../$components/value.svelte'

    let loading = false

    getWalletUser()

    async function getWalletUser() {

        loading = true
        const resp = await WalletsService.getWalletUser($UserStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
            
        WalletStore.set(resp.data)
    }

</script>

<Spinner {loading} />

{#if $WalletStore && !loading}
    <div class="columns">
        <div class="column is-narrow">
            <div class="subtitle">Saldo</div>
            <div class="columns">
                <div class="column">
                    <Value label="Monto" value={ `$ ${ $WalletStore.amount }` } />
                </div>
            </div>
        </div>
    </div>
{/if}